import { render, staticRenderFns } from "./UserMenuItems.vue?vue&type=template&id=4caea83c&scoped=true&"
import script from "./UserMenuItems.vue?vue&type=script&lang=js&"
export * from "./UserMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caea83c",
  null
  
)

export default component.exports